import React from "react";
import { MenuBoxColorMap, MenuBoxProps, MenuBoxSizeMap } from "./menuBox.types";
import './styles.scss'

export const MenuBox: React.FC<MenuBoxProps> = ({
    ...props
}) => {
    const MenuSize = MenuBoxSizeMap.get(props.size)
    const MenuColor = MenuBoxColorMap.get(props.color)

    return (
        <div className="menubox" style={{ height: MenuSize?.size, width: MenuSize?.size }}>
            <div className="menubox2" style={{ height: MenuSize?.size, width: MenuSize?.size, backgroundColor: MenuColor?.backgroundColor }}
                onClick={() => props.onClick && props.onClick()}
                >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    {
                        props.icon && props.icon
                    }
                    <div className="menubox-title" style={{ color: MenuColor?.titleColor, fontSize: MenuSize?.titleFontSize }}>{props.title}</div>
                    {
                        props.subtitle && (
                            <div className="menubox-text-content" style={{ color: MenuColor?.contentColor, fontSize: MenuSize?.subtitleFontSize }}>{props.subtitle}</div>
                        )
                    }
                </div>
            </div>
        </div>

    )
}